/**
 * The site-wide copy for the delivery proof band and strip.
 *
 * Here rather than in `pages/deliveries/content.ts` because this is the band
 * that appears on seven other pages, and page-local copy that another page
 * imports is page-local copy in the wrong file. The gallery's own headings
 * stay with the gallery.
 *
 * One claim, in several lengths. Every variant below says the same thing — we
 * have handed cars over and here they are — because a band that promised
 * something slightly different on each page would be seven slightly different
 * promises to keep. What changes between them is how much room the host page
 * can spare, not what is being said.
 */

export const GALLERY_PATH = '/deliveries/gallery';

/** The call to action, identical everywhere so it is recognisably one place. */
export const deliveryProofCta = { label: 'See delivered cars', to: GALLERY_PATH } as const;

/** Drawn inside the lightbox and the reel, wherever they are opened from. */
export const deliveryViewerCta = { label: 'Get my quotation', to: '/quote' } as const;

/**
 * The full band: a heading, a lede, a wall of tiles, one button.
 *
 * Used where the page has a band to spare and the argument needs making —
 * the home page, the import pages, About.
 */
export const deliveryProofBand = {
  eyebrow: 'Delivered cars',
  title: 'Cars already with their owners',
  lede: 'Not renders and not stock photographs. These are our own handovers — the car, the customer, and the day it reached them.',
} as const;

/**
 * The compact strip: one line and a row that scrolls.
 *
 * Used where the band would be an interruption — beside a car somebody is
 * already looking at, or under a form they have just submitted.
 */
export const deliveryProofStrip = {
  title: 'Cars we have delivered',
  lede: 'Real handovers, photographed and filmed by our own team.',
} as const;
